module.exports = __webpack_public_path__ + "img/mining-drill.e26630ee.png";